import Typography from "@mui/material/Typography";
import React from "react";

type TryLoginMessageProps = {
  // サーバ(権威)が返した残り試行回数
  remaining: number;
  maxAttempts: number;
  // ロック解除までの残り秒数(> 0 ならロック中)。親(LoginForm)がカウントダウンする。
  lockSeconds: number;
};

export const TryLoginMessage: React.FC<TryLoginMessageProps> = ({
  remaining,
  maxAttempts,
  lockSeconds,
}) => {
  if (lockSeconds > 0) {
    const message = `次にアクセス可能な時間: ${Math.floor(lockSeconds / 60)}分 ${
      lockSeconds % 60
    }秒後`;
    return <Typography variant="body2">{message}</Typography>;
  }

  return (
    <Typography variant="body2" align="center">
      残りのログイン試行回数: {remaining} 回 / {maxAttempts}回
    </Typography>
  );
};
